export function MadeInIndiaSection() {
  return (
    <section className="py-16 bg-gradient-to-r from-orange-50 via-white to-green-50">
      <div className="container mx-auto px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_1a0116e9-0e1c-4654-ab92-f289746b4b85/artifacts/k5jfyza7_ChatGPT%20Image%20Dec%2024%2C%202025%2C%2011_29_33%20AM.png"
              alt="Made in India"
              className="h-24 w-auto"
            />
          </div>
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4 text-foreground">
            Proudly Made in India
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            All our modular furniture is designed and manufactured in India, supporting local craftsmanship, sustainable sourcing, and world-class production standards.
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
              <div className="text-3xl mb-2">🏭</div>
              <p className="text-sm font-bold text-foreground">In-House Manufacturing</p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
              <div className="text-3xl mb-2">🇮🇳</div>
              <p className="text-sm font-bold text-foreground">Made in India</p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
              <div className="text-3xl mb-2">🛠️</div>
              <p className="text-sm font-bold text-foreground">Customizable Designs</p>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-md border border-gray-100">
              <div className="text-3xl mb-2">✅</div>
              <p className="text-sm font-bold text-foreground">Quality Certified</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function EzeefitPromiseSection() {
  const promiseCards = [
    { title: 'State-of-Art Production', desc: 'At our production facility in Mumbai, all work is done on machines — from Cutting of panels to Edge banding, Post forming, Hot Pressing, Drilling, Boring, and more.', gradient: 'from-red-500 to-orange-500', icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
    { title: 'Latest Equipment', desc: 'Ezeefit Modular Furniture Pvt. Ltd. is a well-equipped company with the latest equipment and gadgets for providing optimum outputs and support.', gradient: 'from-blue-500 to-cyan-500', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
    { title: 'Quality, Speed & Elegance', desc: 'It is the accuracy that ensures Ezeefit to be the best in terms of Quality, Speed and Elegance. Independent quality controllers check thoroughly from start to final product.', gradient: 'from-emerald-500 to-green-500', icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' },
    { title: 'Expert Team', desc: 'A team of experts supports the unit by updating about the latest products and features. Products are designed maintaining high creative features to satisfy every client\'s needs.', gradient: 'from-purple-500 to-pink-500', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
    { title: 'Standardized Practices', desc: 'Ezeefit maintains standardized tools and business practices to design the best of durable furniture range with consistency and reliability.', gradient: 'from-amber-500 to-yellow-500', icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4' },
    { title: '10+ Years Legacy', desc: 'Since 2014, we\'ve been delivering workspace excellence. Whether it\'s one desk or a whole floor, you\'re backed by a decade of manufacturing expertise.', gradient: 'from-red-600 to-orange-600', special: true, icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' }
  ];

  return (
    <section id="ezeefit-promise" className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white scroll-mt-32">
      <div className="container mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black uppercase mb-4">
            The Ezeefit Promise
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-orange-500 mx-auto mb-6"></div>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            Ezeefit comprises a strong team of dedicated and creative experts. Perfection is the utmost need for them to handle the entire work procedure, in order to serve the best to the customers.
          </p>
        </div>

        {/* Promise Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {promiseCards.map((card, i) => (
            <div 
              key={i} 
              className={`${card.special ? 'bg-gradient-to-br from-red-600/20 to-orange-600/20 border-red-500/30 hover:border-red-500/50' : 'bg-white/5 border-white/10 hover:bg-white/10'} backdrop-blur-sm border p-6 rounded-xl transition-all duration-300 group`}
            >
              <div className={`w-14 h-14 bg-gradient-to-br ${card.gradient} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={card.icon} />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">{card.title}</h3>
              <p className="text-slate-400 text-sm leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-red-400 font-bold">
            Learn more about Ezeefit's capabilities at www.ezeefitofficesystems.in
          </p>
        </div>
      </div>
    </section>
  );
}
